var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-bg"},_vm._l((_vm.points),function(point){return _c('div',{key:point.id,staticClass:"grid-point",style:(_vm.pointStyle(point))})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }